import SamsungApi from "./Api/internal/serviceapi/samsung"
import LookUpValue from "./Api/internal/service/Service21/LookUpValue";



const _resolvers = async (props) => {
    if (props.SamsungApi) return (await SamsungApi(props));
    if (props.LookUpValue) return (await LookUpValue(props));

    return null;
}

export default _resolvers;